/** The Spanish catalogue for the match and how it ended — the wording only. Why each entry exists is argued in `en/match.ts`. */
export default {
  won: 'GANASTE',
  won_timeout: 'GANASTE · POR TIEMPO',
  lost: 'PERDISTE',
  timeout: 'SE ACABÓ EL TIEMPO',
  draw: 'EMPATE',
  captured_won: 'BANDERA CAPTURADA',
  captured_lost: 'BANDERA PERDIDA',
  objective_done: 'MISIÓN CUMPLIDA',
  objective_failed: 'MISIÓN FALLIDA',
  col_kills: 'Bajas',
  col_downs: 'Caídas',
  stat_enemies: 'Enemigos eliminados',
  stat_kills: 'Bajas',
  stat_downs: 'Caídas',
  stat_time: 'Tiempo',
  again: 'Jugar de nuevo',
  again_btn: 'Nueva partida',
  enemies: 'Enemigos',
};
